module.exports = __webpack_public_path__ + "static/media/jobs.317a6df4.jpg";